import Stickyfill from 'stickyfilljs/dist/stickyfill.min';

const getSubmenu = $('section.s-submenu');
// const getSubmenuClone = $('section.s-submenu--clone');

var lastScrollTop = 0;

function fixedMenu() {
    // Submenu pushing away main/top menu
    // var initSubmenuPosition = getSubmenu.position().top;
    const submenuButton = $('.s-submenu__button-right');
    submenuposition = getSubmenu.position().top;

    if ($(window).scrollTop() < submenuposition - navHeight) {
        $('header').css('top', '0px');
        getSubmenu.css('top', '0px');
        submenuButton.css('display', 'none');
    } else {
        correctionMargin = submenuposition - $(window).scrollTop();
        submenuButton.css('display', 'block');

        if (correctionMargin <= 0) {
            correctionMargin = 0;
            subcorrectionMargin = 0;
        } else {
            subcorrectionMargin = navHeight + correctionMargin;
        }

        console.log('Correction = ' + correctionMargin);
        $('header').css('top', '-' + (navHeight - correctionMargin) + 'px');
        getSubmenu.css('top', -subcorrectionMargin + 'px');

        var st = $(window).scrollTop();
        var siteHeader = $('.site-header');
        var hh = siteHeader.height();
        if (st < lastScrollTop) {
            siteHeader.addClass('fixed-header');
            siteHeader.css('top', '0');
            getSubmenu.css('top', hh + 'px');
        } else {
            siteHeader.removeClass('fixed-header');
            siteHeader.css('top', '-' + hh + 'px');
            getSubmenu.css('top', '0');
        }
        lastScrollTop = st;
    }
}

let $currSection, clr;
let submenuHeight = getSubmenu.height();
function updateActiveAnchor() {
    // Update anchor based on which section is visible
    $('section').each(function () {
        var section = $(this);
        let sectionMargin = parseInt($(section).css('margin-top'));

        var position = $(window).scrollTop() + submenuHeight - section.position().top + sectionMargin;

        if (position >= sectionMargin) {
            if (section.attr('id') !== undefined) {
                $currSection = section.attr('id');
            }
        }
    });

    clearTimeout(clr);
    clr = setTimeout(function () {
        // assign the active class to a link to most visible section
        $('.s-submenu a.c-submenu__link').each(function () {
            if ($(this).attr('href') === '#' + $currSection && $currSection !== 'section-number-1') {
                $(this).parent().addClass('anchor-active');
            } else {
                $(this).parent().removeClass('anchor-active');
            }
        });
    }, 70);
}

function anchorScroll() {
    $('.s-submenu a.c-submenu__link').each(function () {
        let clickSectionMargin = $(this).attr('href');
        let sectionMargin = parseInt($(clickSectionMargin).css('margin-top'));
        $(this).click(function (e) {
            e.preventDefault();
            if ($(window).width > 576) {
                if (sectionMargin > 0) {
                    $('html, body').animate(
                        {
                            scrollTop: $($.attr(this, 'href')).offset().top - 51 - sectionMargin + 1,
                        },
                        500
                    );
                } else {
                    $('html, body').animate(
                        {
                            scrollTop: $($.attr(this, 'href')).offset().top - 51,
                        },
                        500
                    );
                }
            } else {
                $('html, body').animate(
                    {
                        scrollTop: $($.attr(this, 'href')).offset().top - $('.s-submenu').height() - sectionMargin + 1,
                    },
                    500
                );
            }
        });
    });
}

// only run this code if the section is on the page
if (getSubmenu.length !== 0) {
    var stickySubmenu = $('.s-submenu--sticky');
    Stickyfill.add(stickySubmenu);

    // var $currSection;
    var submenuposition = false;
    var navHeight = false;
    var correctionMargin = false;
    var subcorrectionMargin = false;
    // var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var hasStickySubmenu = stickySubmenu.length;

    if (hasStickySubmenu) {
        // remove bottom margin from the section before s-submenu--sticky
        let sectionBeforeSubmenu = stickySubmenu.prev();
        sectionBeforeSubmenu.css('margin-bottom', '0');
    }
    //
    // if (isSafari && hasStickySubmenu) {
    //     // create a twin sister fo the submenu which will keep the space in the document
    //     // when the first submenu is positioned fixed
    //     var submenuClone = $('.s-submenu').clone();
    //
    //     submenuClone
    //         .removeClass() //
    //         .addClass('s-submenu--clone')
    //         .css('position', 'static')
    //         .css('display', 'block')
    //         .css('visibility', 'visible')
    //         .insertAfter($('.s-submenu'));
    // }

    $(window).load(function () {
        navHeight = $('header').outerHeight();
        submenuposition = getSubmenu.position().top;

        anchorScroll();
        fixedMenu();
    });

    $(window).resize(function () {
        navHeight = $('header').outerHeight();
        submenuposition = getSubmenu.position().top;

        anchorScroll();
        fixedMenu();
    });

    $(window).scroll(function () {
        clearTimeout(clr);
        updateActiveAnchor();
        fixedMenu();
    });
}



// WEBPACK FOOTER //
// ./scripts/routes/sections/submenu.js